import React, { Ref, forwardRef, HTMLProps } from 'react';
import { classNames } from 'primereact/utils';
import './Field.scss';

type FieldProps = Pick<HTMLProps<HTMLLabelElement>, 'id' | 'className' | 'htmlFor' | 'children'> & {
	label: string;
	required?: boolean;
	horizontal?: boolean;
	containerClassName?: string;
	contentClassName?: string;
	errorMessage?: string;
};

export const Field = forwardRef(
	(
		{
			label,
			required,
			horizontal = false,
			className,
			containerClassName,
			contentClassName,
			errorMessage,
			children,
			...props
		}: FieldProps,
		ref: Ref<HTMLLabelElement>
	) => {
		return (
			<div className={classNames('field', { 'field-horizontal': horizontal }, containerClassName)}>
				<label ref={ref} className={classNames('field-label', className)} {...props}>
					{label}
				</label>
				<div className="field-body">
					<div className={classNames('flex flex-column gap-1', contentClassName)}>{children}</div>
					{errorMessage ? <div className="field-message text-danger">{errorMessage}</div> : null}
				</div>
			</div>
		);
	}
);
